import { render, staticRenderFns } from "./add.vue?vue&type=template&id=2ecd4762&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ecd4762",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ecd4762')) {
      api.createRecord('2ecd4762', component.options)
    } else {
      api.reload('2ecd4762', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=2ecd4762&scoped=true&", function () {
      api.rerender('2ecd4762', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/dialogs/add.vue"
export default component.exports